import styled from 'styled-components';

export const OrLabel = styled.div`
  user-select: none;
  text-align: left;
  margin: auto auto 20px 0px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1c2243;
`;

OrLabel.displayName = 'OrLabel';

export const RuleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
RuleWrapper.displayName = 'RuleWrapper';
